// extracted by mini-css-extract-plugin
export default {"socialLink":"SocialLink_socialLink__4WzZC","tooltip":"SocialLink_tooltip__mxhnS","filterLight":"SocialLink_filterLight__Iar8P","filterDark":"SocialLink_filterDark__WVI63"};